<template>
  <div v-if="visible">
    <transition name="slide-fade" @before-leave="onBeforeLeave">
      <div class="message-box">
        <p>{{ message }}</p>
        <button class="close-btn" @click="closeMessage">X</button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'newMessage',
  props: {
    msg: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      message: '',
      visible: false,
      timeoutId: null,
    };
  },
  watch: {
    msg: {
      handler(newVal) {
        this.showMessage({ ...{ msg: "", time: 30 }, ...newVal });
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {
    showMessage({ msg, time }) {
      this.message = msg;
      this.visible = true;

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      this.timeoutId = setTimeout(() => {
        this.visible = false;
      }, time * 1000);
    },
    closeMessage() {
      this.visible = false;
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
    },
    onBeforeLeave(el) {
      el.style.transform = 'translateX(100%)';
    },
  },
  unmounted() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  },
};
</script>

<style scoped>
.message-box {
  position: fixed;
  bottom: 20px; /* Cambia 'top' por 'bottom' */
  right: 20px;
  background-color: #333;
  color: #fff;
  padding: 10px 20px;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 90%; /* Asegúrate de que no ocupe todo el ancho en móviles */
  box-sizing: border-box;
}

.message-box p {
  margin: 0;
  word-wrap: break-word; /* Permite que el texto se ajuste */
}

.close-btn {
  background: none;
  border: none;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 3s ease, background-color 4s ease;
}

.slide-fade-enter {
  transform: translateX(100%);
  background-color: gray;
  opacity: 0.1;
}
.slide-fade-leave-to {
  transform: translateX(100%);
  background-color: white;
  opacity: 0;
}

/* Estilos específicos para móviles */
@media (max-width: 768px) {
  .message-box {
    bottom: 10px; /* Reduce la distancia inferior en móviles */
    right: 10px;
    max-width: 95%; /* Ocupa más ancho en móviles */
    padding: 8px 15px; /* Ajusta el padding */
  }
  .close-btn {
    font-size: 14px; /* Botón más pequeño */
  }
}
</style>
